import { NgxSpinnerService } from "ngx-spinner";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { Pneu } from "../../models/Pneu.model";
import storageX from "../../storageCore/storageX";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "../../storageCore/constStorageKeys";
import { ApiBaseService } from "../../services/migrate/api.base.service";
import { Company } from "src/app/models/Company.model";

@Component({
  selector: "app-create-pneu",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class CreatePneuComponent implements OnInit {
  public pneuForm: FormGroup;
  public title = "Cadastrar Pneu";
  public errorMessage;
  private apiBaseService: ApiBaseService;
  public tirePositionFilterSelected;
  public pneuId: number;

  public empresaSelected;
  public empresaFilterSelected;

  public companies: any = [];
  public companiesFilter: any = [];
  public companiesSelect: any = [
    { name: "Divisão", value: 1 },
    { name: "Matriz", value: 2 },
    { name: "Filial", value: 3 },
  ];

  constructor(
    apiBaseService: ApiBaseService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.apiBaseService = apiBaseService;
  }

  public namePositionSelect = [];

  ngOnInit(): void {
    this.pneuForm = this.formBuilder.group(
      {
        idEmpresa: ["", Validators.required],
        selecaoEmpresa: ["", Validators.required],
        marca: ["", Validators.required],
        tamanho: ["", Validators.required],
        numeroFogo: ["", Validators.required],
        kmEntrada: [""],
        kmSaida: [""],
        observacao: [""],
      },
      { updateOn: "blur" }
    );

    this.setup();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async setup(): Promise<void> {
    try {
      const params = {
        size: 999999,
        page: 0,
        profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      };

      const result = await this.apiBaseService.get<any>({
        url: new Company()["nomeConsultaApiBaseGetAll"],
        params,
      });

      this.companies = result["content"];

      this.spinner.hide();
    } catch (error) {
      console.error(error);
    }
  }

  public filterCompany() {
    var idEmpresa = this.empresaFilterSelected;
    var empresas = [];

    if (idEmpresa == "Divisão") {
      this.companies.forEach((element) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Matriz") {
      this.companies.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Filial") {
      this.companies.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;
  }

  public async submitForm(): Promise<void> {
    this.spinner.show();
    try {
      this.coverterUpperCase(this.pneuForm);
      const values = this.pneuForm.value;
      var post;

      if (this.empresaFilterSelected != "Divisão") {
        post = {
          ...values,
          empresa: {
            id: parseInt(values.idEmpresa),
          },
          divisao: null,
          idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
      } else {
        post = {
          ...values,
          divisao: {
            id: parseInt(values.idEmpresa),
          },
          empresa: null,
          idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
      }

      const result = await this.apiBaseService.post<Pneu>(
        new Pneu()["nomeConsultaApiBase"],
        post
      );
      this.spinner.hide();
      this.router.navigate(["/pneu/edit/" + result.id]);
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public coverterUpperCase(pneuForm: FormGroup) {
    pneuForm.get("marca").setValue(pneuForm.get("marca").value.toUpperCase());

    pneuForm
      .get("tamanho")
      .setValue(pneuForm.get("tamanho").value.toUpperCase());

    pneuForm
      .get("numeroFogo")
      .setValue(pneuForm.get("numeroFogo").value.toUpperCase());

    pneuForm
      .get("observacao")
      .setValue(pneuForm.get("observacao").value.toUpperCase());
  }
}
